import { format, addDays } from 'date-fns';
import { patterHeaderStyle, patternCellStyle } from '../../table/stylesReport';

const date = new Date();
const now = format(addDays(date, -1), "yyyy-MM-dd'T'HH:MM");
const now24 = format(date, "yyyy-MM-dd'T'HH:MM");

export const initFilter = {
  speed: 0,
  speedCondition: '0',
  startDateTime: now,
  endDateTime: now24,
};
const nowDate = format(addDays(date, -1), 'yyyy-MM-dd');
const nowDate24 = format(date, 'yyyy-MM-dd');

export const initDateFilter = {
  startDateTime: nowDate,
  endDateTime: nowDate24,
};
export const listEvents = [
  { id: 18, name: 'Positions' },
  { id: 2, name: 'stops' },
  { id: 3, name: 'Ignition' },
  { id: 4, name: 'Sensors' },
  { id: 5, name: 'Regions' },
  { id: 6, name: 'Alarms' },
  { id: 7, name: 'SerialPort' },
  { id: 8, name: 'TabletEvents' },
];

export const optionsSpeedCondition = [
  { value: '0', text: 'Speed' },
  { value: 'gto', text: '>=' },
  { value: 'lwo', text: '<=' },
  { value: 'equ', text: '=' },
];

export const columnsTable = [
  {
    title: 'VEHICLES',
    field: 'plate',
    cellStyle: {
      minWidth: '8%',
      maxWidth: '10%',

      ...patternCellStyle,
      paddingLeft: '8px',
    },
    headerStyle: {
      ...patterHeaderStyle,
      paddingLeft: '8px',
      // width: '80px',
    },
  },
  {
    title: 'DRIVER',
    field: 'driver',
    cellStyle: {
      minWidth: '7%',
      maxWidth: '8%',
      ...patternCellStyle,
    },
    headerStyle: {
      ...patterHeaderStyle,
      // width: '50px',
      // maxWidth: '120px',
    },
  },
  /*{
    title: 'function',
    field: 'description',
    cellStyle: {
      minWidth: '7%',
      maxWidth: '8%',
      ...patternCellStyle,
    },
    headerStyle: {
      ...patterHeaderStyle,
      // width: '50px',
      // maxWidth: '120px',
    },
  },*/
  {
    title: 'EVENTS',
    field: 'event_type',
    cellStyle: {
      minWidth: '8%',
      maxWidth: '12%',
      ...patternCellStyle,
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },
  {
    title: 'START_DATE_TIME',
    field: 'start_time',
    cellStyle: {
      ...patternCellStyle,
      width: '11%',
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },
  {
    title: 'END_DATE_TIME',
    field: 'end_time',
    cellStyle: {
      ...patternCellStyle,
      width: '11%',
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },
  {
    title: 'TOTAL_DURATION_MS',
    field: 'durationms',
    filtering: false,
    cellStyle: {
      // maxWidth: '10%',
      width: '3%',
      ...patternCellStyle,
    },
    headerStyle: { ...patterHeaderStyle },
  },
  /*{
    title: 'ODOMETER',
    field: 'odometer',
    filtering: false,
    cellStyle: {
      width: '6%',
      maxWidth: '7%',
      ...patternCellStyle,
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },
  {
    title: 'IGNITION',
    field: 'ignition',
    // type: 'numeric',
    cellStyle: {
      width: '8%',
      maxWidth: '9%',
      ...patternCellStyle,
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },*/
  {
    title: 'EVENT_VALUE',
    field: 'event_value',
    filtering: false,
    cellStyle: {
      ...patternCellStyle,
      minWidth: '25%',
      width: '30%',
      maxWidth: '35%',
    },
    headerStyle: {
      ...patterHeaderStyle,
    },
  },
];
